import { render, staticRenderFns } from "./ExpenseCard.vue?vue&type=template&id=5ab37ed7"
import script from "./ExpenseCard.vue?vue&type=script&lang=js"
export * from "./ExpenseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports